<template>
  <div class="schoolBasic">
      <b class="txt-lh36 txt-111 rel">
          {{classInfo.name}}</b>
      <p class="txt-lh28 txt-666 mt15 pl35 time">
          {{classInfo.time}}／{{classInfo.courseTotal}}课次
      </p>
  </div>
</template>
<style lang="less" src="./SchoolBasic.less">

</style>
<script>
export default {
  name: 'SchoolBasic',
  props: {
    classInfo: Object
  },
  data(){
    return {}
  },
  mounted(){
    console.log('class info in school basic:', this.classInfo);
  }
}
</script>


// WEBPACK FOOTER //
// src/components/courseCenter/newsign/SchoolBasic.vue